function downloadBlob(blob: Blob, name: string) {
	const urlBlob = URL.createObjectURL(blob);
	const link = document.createElement("a");

	link.href = urlBlob;
	link.download = name;

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);

	URL.revokeObjectURL(urlBlob);
}

export { downloadBlob };
